export type AlertVariant = 'danger' | 'info' | 'success' | 'warning'
